import script from "./InductionCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./InductionCompleted.vue?vue&type=script&setup=true&lang=js"

import "./InductionCompleted.vue?vue&type=style&index=0&id=6a3755ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a3755ee"]])

export default __exports__